import React, { MouseEventHandler, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import UseWindowWidth from "../../hooks/UseWindowWidth";
import onContentChange from "../../hotel_integration_modules/utilities/onContentChange";
import styled from "styled-components";
import I18n from "../../translations/i18n";
import { BookingEngine } from "../../hotel_integration_modules";

interface TotalBannerProps {
  bookingEngine: BookingEngine;
  totalBannerTarget: Element;
  setShowHoverOver: (a: boolean) => void;
  currency: string;
  setMessagingHeight: (a: number) => void;
  setHoverOverSide: (a: "left" | "right") => void;
  setMessagingCoordinates: (a: [number, number]) => void;
  messageActive: boolean;
  showMessaging: boolean;
  showHoverOver: boolean;
};

interface BannerMessagingProps {
  messageActive: boolean;
}

const TotalBannerContainer = styled.div`
  font-family: ${({ theme }) => theme.primaryFont};
  position: relative;
  display: flex;
  justify-content: end;
`;

const BannerMessaging = styled.div<BannerMessagingProps>`
  font-weight: 600 !important;
  cursor: pointer !important;
  color: ${({ theme }) => theme.primaryColor}; 
  outline: 0;
  display: flex;
  flex: 1;
  justify-content: space-between;

  &:focus {
    text-decoration: underline;
  }
  width: max-content;
`;

const TotalBanner = ({
  bookingEngine,
  setShowHoverOver,
  currency,
  setMessagingHeight,
  setHoverOverSide,
  setMessagingCoordinates,
  messageActive,
  showMessaging,
  showHoverOver,
}: TotalBannerProps) => {
  const WindowWidth = UseWindowWidth();
  const isDesktopWidget = WindowWidth > bookingEngine.widgetMobileAtWidth - 1;
  const [rewards15, setRewards15] = useState(bookingEngine.getRewards(0.15));
  const beiDocument = bookingEngine.shadowRoot || document;
  const [totalBannerTarget, setTotalBannerTarget] = useState(null);
  const rateExcluded = sessionStorage.getItem('rateExcluded') === 'true';

  useEffect(() => {
    if (bookingEngine.name === 'bobw') {
      const onDetailsPage = !!!document.querySelector(bookingEngine.selectors.paymentPage.email);
      const totalBannerTargets = Array.from(document.querySelectorAll(bookingEngine.selectors.paymentPage.totalBannerTarget))
      const shouldDisplayBannerContainer = !rateExcluded && (onDetailsPage || messageActive);
      const displayStyle = shouldDisplayBannerContainer ? 'block' : 'none';

      for (const bannerTargetEl of totalBannerTargets) {
        const bannerTarget = bannerTargetEl as HTMLElement;
        const previousSibling = (bannerTarget.previousSibling as HTMLElement);
        previousSibling.style.display = displayStyle;
        bannerTarget.style.display = displayStyle;
      }

      if (!shouldDisplayBannerContainer) {
        setTotalBannerTarget(null);
        return;
      }
    }

    bookingEngine.createTotalBannerContainer();
    setTotalBannerTarget(bookingEngine.getTotalBannerTarget());
  }, [isDesktopWidget, rewards15, messageActive, rateExcluded]);

  onContentChange(
    bookingEngine.selectors.paymentPage.contentChangeTarget,
    () => {
      setRewards15(bookingEngine.getRewards(0.15));
    },
    beiDocument,
  );

  const handleMouseEnter = (e: React.MouseEvent) => {
    if (window.innerWidth > 768) {
      // Calculate the position for hover over
      const messagingRect = e.currentTarget.getBoundingClientRect();
      setMessagingHeight(messagingRect.height);
      const rect = e.currentTarget.getBoundingClientRect();

      let offsetX;
      let offsetY = rect.y + window.scrollY + rect.height / 2;

      if (rect.x + rect.width + window.scrollX + 319 > window.innerWidth) {
        setHoverOverSide('left');
        offsetX = rect.x + window.scrollX;
      } else {
        setHoverOverSide('right');
        offsetX = rect.x + rect.width + window.scrollX;
      }

      setMessagingCoordinates([offsetX, offsetY]);
    }

    if (bookingEngine.name === 'bobw') return;

    setShowHoverOver(true);
  }

  const handleMouseLeave = () => {
    if (bookingEngine.name === 'bobw') return;

    setShowHoverOver(false);
  }

  const handleClick = (e) => {
    e.stopPropagation();

    if (bookingEngine.name === 'bobw') {
      setShowHoverOver(!showHoverOver);
    } else {
      setShowHoverOver(true);
    }
  }

  if (totalBannerTarget && showMessaging) {
    return ReactDOM.createPortal(
      <TotalBannerContainer className="total-banner-container">
        <BannerMessaging
          className="total-banner-messaging"
          onClick={handleClick}
          onMouseOver={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          messageActive={messageActive}
        >
          <div>
            {I18n.t("views.hotel_integration.components.total_banner.message")}:
          </div>
          <div>
            {currency}{rewards15}
          </div>
        </BannerMessaging>
      </TotalBannerContainer>,
      totalBannerTarget);
  } else {
    return null;
  }
}

export default TotalBanner;